import { getFirestore, doc, collection, query, where, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'depotArea/'

function docToInstance(document) {
  const data = document.data()
  return data ? new DepotArea(document.id, data.name, data.files, data.isVisible, data.isPrivate, data.isAdmin) : null
}

const allExts = ['pdf', 'txt', 'xls', 'ppt', 'zip', 'image', 'audio', 'video', 'data']

export default class DepotArea {
  constructor(id, name, files = JSON.parse(JSON.stringify(allExts)), isVisible = true, isPrivate = false, isAdmin = false) {
    this.id = id
    this.name = name
    this.files = files
    this.isVisible = isVisible
    this.isPrivate = isPrivate
    this.isAdmin = isAdmin
  }

  async save() {
    const data = {
      name: this.name,
      files: this.files,
      isVisible: this.isVisible,
      isPrivate: this.isPrivate,
      isAdmin: this.isAdmin,
    }

    if (this.id) {
      await catalogueCommands.depotArea.update(this.id, data)
    } else {
      const result = await catalogueCommands.depotArea.create(data)
      this.id = result.id
    }
    return this
  }
  async delete() {
    await catalogueCommands.depotArea.delete(this.id)
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }

  static async getByName(name) {
    const docsQuery = query(
      collection(db, await getCollectionPath(collectionName)),
      where('name', '==', name)
    )

    const res = await getDocs(docsQuery)
    let list = []
    res.forEach(doc => {
      list.push(docToInstance(doc))
    })
    return list
  }
  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list.sort((a,b) => a.name.localeCompare(b.name)))
    })
  }
  static async listenByIsVisible(isVisible, callback) {
    const docsQuery = query(
      collection(db, await getCollectionPath(collectionName)),
      where('isVisible', '==', isVisible)
    )
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list.sort((a,b) => a.name.localeCompare(b.name)))
    })
  }
}